<template>
  <div v-if="visible" class="feedback-overlay" @click.self="close">
    <div class="feedback-dialog" role="dialog" aria-modal="true" aria-labelledby="feedback-title">
      <div class="feedback-icon" :class="`feedback-${type}`">
        <i :class="type === 'success' ? 'bx bx-check' : 'bx bx-error-circle'"></i>
      </div>

      <h3 id="feedback-title">{{ title }}</h3>
      <p>{{ message }}</p>

      <button class="feedback-button" @click="close">OK</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "FeedbackDialog",

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Notice",
    },
    message: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "error",
    },
  },

  emits: ["close"],

  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.feedback-overlay {
  position: fixed;
  inset: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(15, 23, 42, .5);
  backdrop-filter: blur(4px);
}

.feedback-dialog {
  width: min(100%, 380px);
  box-sizing: border-box;
  padding: 24px;
  border: 1px solid #E2E8F0;
  border-radius: 16px;
  background: #FFFFFF;
  box-shadow: 0 25px 60px rgba(15, 23, 42, .2);
  text-align: center;
}

.feedback-icon {
  width: 52px;
  height: 52px;
  margin: 0 auto 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  font-size: 26px;
}

.feedback-icon.feedback-success {
  background: #ECFDF5;
  color: #059669;
}

.feedback-icon.feedback-error {
  background: #FEF2F2;
  color: #DC2626;
}

.feedback-dialog h3 {
  margin: 0;
  color: #0F172A;
  font-size: 17px;
}

.feedback-dialog p {
  margin: 8px 0 18px;
  color: #64748B;
  font-size: 12px;
  line-height: 1.5;
  overflow-wrap: anywhere;
}

.feedback-button {
  min-width: 84px;
  height: 40px;
  padding: 0 15px;
  border: none;
  border-radius: 9px;
  background: #2563EB;
  color: #FFFFFF;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.feedback-button:hover {
  background: #1D4ED8;
}
</style>
